import React, { useState } from 'react';
import { AdminLogin } from '../components/admin/AdminLogin';
import { AdminDashboard } from '../components/admin/AdminDashboard';
import { getToken, clearToken } from '../api';

export default function AdminPage() {
  const [authed, setAuthed] = useState(!!getToken());

  const handleLogout = () => {
    clearToken();
    setAuthed(false);
  };

  if (!authed) {
    return <AdminLogin onSuccess={() => setAuthed(true)} />;
  }
  return <AdminDashboard onLogout={handleLogout} />;
}
